import React from "react";
import { Link } from "react-router-dom";
import { BsGithub, BsLinkedin } from "react-icons/bs";
import { SiHashnode } from "react-icons/si";
import "./CSS/home.css";
import AutoType from "./AutoType";
import image from "../assets/image-1.jpg";
import CardItem from "./Carditem";
import BlogItem from "./BlogItem";

export default function Home({ data }) {
  const profile = data.profile?.[0] || {};
  const projects = data.project || [];
  const blogs = data.blogs || [];
  const baseSkills = profile.Skills ? profile.Skills.split(",").map((skill) => skill.trim()) : [];
  const skillSet = new Set(baseSkills);
  skillSet.add("Java");
  skillSet.add("Spring Boot");
  const skills = Array.from(skillSet);

  const featuredProjects = projects.slice(0, 3);
  const featuredBlogs = blogs.slice(0, 3);

  document.title = "Aritra Bhattacharjee";

  return (
    <div className="page">
      <section className="container-narrow hero">
        <div className="hero-grid">
          <div className="fade-up">
            <p className="eyebrow">Java | Spring Boot | Python | Web | ML</p>
            <h1 className="display">Building developer-friendly products and tools.</h1>
            <p className="lead">
              {profile.about || "I build practical software and share what I learn."}
            </p>
            <div className="hero-cta">
              <Link className="btn btn-primary" to="/projects">
                View Projects
              </Link>
              <Link className="btn btn-outline-light" to="/contact">
                Start a Conversation
              </Link>
              <Link className="btn btn-outline-light" to="/resume">
                Download Resume
              </Link>
            </div>
            <div className="hero-social">
              <a
                href="https://www.linkedin.com/in/aritra-bhattacharjee/"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <BsLinkedin />
              </a>
              <a
                href="https://github.com/AritraBhattacharjee"
                target="_blank"
                rel="noreferrer"
                aria-label="GitHub"
              >
                <BsGithub />
              </a>
              <a
                href="https://hashnode.com/@AritraBhattacharjee"
                target="_blank"
                rel="noreferrer"
                aria-label="Hashnode"
              >
                <SiHashnode />
              </a>
            </div>
            <div className="stats-row">
              <div className="stat-card">
                <h3>{projects.length}+</h3>
                <span className="muted">Projects shipped</span>
              </div>
              <div className="stat-card">
                <h3>{blogs.length}+</h3>
                <span className="muted">Technical articles</span>
              </div>
              <div className="stat-card">
                <h3>{skills.length}+</h3>
                <span className="muted">Tools in toolkit</span>
              </div>
            </div>
          </div>
          <div className="hero-visual float">
            <div className="portrait-card">
              <img src={image} alt={profile.name || "Profile"} />
              <div className="status-chip">Open to developer roles</div>
              <div className="divider"></div>
              <AutoType />
            </div>
          </div>
        </div>
      </section>

      <section className="container-narrow section">
        <div className="section-header">
          <div>
            <p className="eyebrow">Focus Areas</p>
            <h2 className="section-title">How I create impact</h2>
          </div>
        </div>
        <div className="section-grid">
          <div className="feature-card">
            <h4>Productive web apps</h4>
            <p className="muted">
              Responsive, fast, and accessible interfaces with thoughtful UX that scale well.
            </p>
          </div>
          <div className="feature-card">
            <h4>Python + automation</h4>
            <p className="muted">
              APIs, scripts, and workflow tools that remove manual effort and speed up teams.
            </p>
          </div>
          <div className="feature-card">
            <h4>ML experimentation</h4>
            <p className="muted">
              Practical ML prototypes with clear evaluation, explainability, and documentation.
            </p>
          </div>
        </div>
      </section>

      <section className="container-narrow section">
        <div className="section-header">
          <div>
            <p className="eyebrow">Featured</p>
            <h2 className="section-title">Selected projects</h2>
            <p className="muted">A quick glance at my most relevant work.</p>
          </div>
          <Link className="btn btn-outline-light" to="/projects">
            Explore all
          </Link>
        </div>
        <div className="row g-4 mt-2">
          {featuredProjects.map((project) => (
            <div className="col-md-4" key={project.title}>
              <CardItem
                title={project.title}
                description={project.description}
                date={project.date}
                tech={project.tech}
                project_url={project.project_url}
              />
            </div>
          ))}
        </div>
      </section>

      <section className="container-narrow section">
        <div className="section-header">
          <div>
            <p className="eyebrow">Writing</p>
            <h2 className="section-title">Latest articles</h2>
            <p className="muted">Sharing what I learn so others can build faster.</p>
          </div>
          <Link className="btn btn-outline-light" to="/blogs">
            Read all
          </Link>
        </div>
        <div className="row g-4 mt-2">
          {featuredBlogs.map((blog) => (
            <div className="col-md-4" key={blog.title}>
              <BlogItem
                title={blog.title}
                description={blog.brief}
                project_url={`https://aritrablogs.hashnode.dev/${blog.slug}`}
                imageUrl={blog.coverImage}
              />
            </div>
          ))}
        </div>
      </section>

      <section className="container-narrow section">
        <div className="callout">
          <p className="eyebrow">Toolbox</p>
          <h2 className="section-title">Technologies I use daily</h2>
          <div className="tools">
            {skills.map((skill) => (
              <span className="tag" key={skill}>
                {skill}
              </span>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
